<template>
    <section class="p-3">
        <header class="d-flex justify-content-between align-items-center">
            <h6 class="fw-bold">Branch History</h6>
            <button type="button" class="btn table-btn px-2 btn-outline-info" @click="closeDialog">
                <i class="fas fa-close icon-size"></i>
            </button>
        </header>
        <div class="h-100 d-flex flex-column mb-3 mt-2">
            <table class="table table-responsive-md border border-gray">
                <thead>
                    <tr class="bg-table-header table-header">
                        <th>Agency Branch</th>
                        <th>Effective Date</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Modified By</th>
                        <th>Modified Date</th>
                        <th>Comments</th>
                        <th v-if="canEditInquiryLocation">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                        <td :colspan="columns">
                            <h3>No Inquiry Branches to show.</h3>
                        </td>
                    </tr>
                    <!-- ERROR -->
                    <tr class="table-error" v-if="!isLoading && isError">
                        <td :colspan="columns">
                            <ErrorMessageHandler title="Inquiry list" :show-try-again="true" :try-again="reset">
                            </ErrorMessageHandler>
                        </td>
                    </tr>

                    <!-- LOADING -->
                    <template v-if="isLoading">
                        <tr v-for="i in 3" class="table-loading" :key="`count-${i}`">
                            <td v-for="i in columns" :key="`column-${i}`">
                                <span class="shimmer-loading"></span>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <template v-if="!isLoading && !isError && hasData">
                    <tbody v-for="location in inquiryLocations" :key="location.id">
                        <tr
                            :class="`border-line ${isEditRequested && location.id === selectedLocation?.id ? 'edit-row td-border' : ''}`"
                        >
                            <td v-if="location.id !== selectedLocation?.id">
                                <EmptyTextHandler :text="location.locationName" />
                            </td>
                            <td v-else>
                                <select class="form-select" v-model="selectedAgencyBranch">
                                    <option :value="null">Select Agency Branch</option>
                                    <option v-for="location of agencyBranches" :value="location.id">
                                        {{ location.name }}
                                    </option>
                                </select>
                            </td>
                            <td><EmptyTextHandler :text="formatDate(location.effectiveDate)" /></td>
                            <td><EmptyTextHandler :text="location.createdBy" /></td>
                            <td><EmptyTextHandler :text="formatDate(location.createdUtc)" /></td>
                            <td><EmptyTextHandler :text="location.modifiedBy" /></td>
                            <td><EmptyTextHandler :text="formatDate(location.modifiedUtc)" /></td>
                            <td><EmptyTextHandler :text="location.comment" /></td>
                            <td v-if="canEditInquiryLocation">
                                <button
                                    type="button"
                                    class="btn table-btn px-2 btn-outline-info"
                                    @click="() => handleEditRequest(location)"
                                    v-if="!isEditRequested && location.id !== selectedLocation?.id"
                                >
                                    <i class="fas fa-edit icon-size"></i>
                                </button>
                                <button
                                    v-if="isEditRequested && location.id === selectedLocation?.id"
                                    type="button"
                                    title="Save"
                                    class="btn table-btn btn-outline-primary"
                                    @click="() => updateInquiryBranch(location)"
                                >
                                    <span v-if="isSaving">
                                        <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                                    </span>
                                    <span v-else>
                                        <i class="fas fa-save icon-size"></i>
                                    </span>
                                </button>
                                <button
                                    v-if="isEditRequested && location.id === selectedLocation?.id"
                                    type="button"
                                    title="Cancel"
                                    class="btn table-btn btn-outline-secondary"
                                    @click="cancelEditLocation"
                                >
                                    <i class="fas fa-times-circle"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </table>
        </div>
    </section>
</template>

<script src="./BranchHistory.ts"></script>
